import { defineMessages } from 'react-intl'

export const scheduleChangeDetailMessages = defineMessages({
  stopArrivalDateTime: {
    id: 'sUGUdbNsa9qeKZaNKaXp',
    defaultMessage: 'Stop at {route}: arrival changed from {previous} to {updated}.',
    description: 'Summary bullet comparing arrival at an intermediate stop within a flight; route is the stop airport code',
  },
  stopDepartureDateTime: {
    id: 'IBxrQjtmCgSbeokzFvKd',
    defaultMessage: 'Stop at {route}: departure changed from {previous} to {updated}.',
    description: 'Summary bullet comparing departure from an intermediate stop within a flight; route is the stop airport code',
  },
  departureAirport: {
    id: 'mADOA0JdHzobFUmn5LdJ',
    defaultMessage: '{route}: departure airport changed from {previous} to {updated}.',
    description: 'Bullet describing a changed departure airport in the flight schedule comparison modal',
  },
  arrivalAirport: {
    id: 'Ksv7Sw8mgmpriRvzsito',
    defaultMessage: '{route}: arrival airport changed from {previous} to {updated}.',
    description: 'Bullet describing a changed arrival airport in the flight schedule comparison modal',
  },
  departureDateTime: {
    id: 'qnneq_t-z4xtKvsDqgEc',
    defaultMessage: '{route}: departure changed from {previous} to {updated}.',
    description: 'Bullet describing a changed departure in the flight schedule comparison modal',
  },
  arrivalDateTime: {
    id: 'YOj0pAmyH6BIbmVxYlzD',
    defaultMessage: '{route}: arrival changed from {previous} to {updated}.',
    description: 'Bullet describing a changed arrival in the flight schedule comparison modal',
  },
  flightNumber: {
    id: 'YsbPiIJIes5EFmLkSjkB',
    defaultMessage: '{route}: flight number changed from {previous} to {updated}.',
    description: 'Bullet describing a changed flight number in the flight schedule comparison modal',
  },
  departureTerminal: {
    id: 'fWZl0UIizJ6jsbKq3mIn',
    defaultMessage: '{route}: departure terminal changed from {previous} to {updated}.',
    description: 'Bullet describing a changed departure terminal in the flight schedule comparison modal',
  },
  arrivalTerminal: {
    id: 'v3UJu-o65nmlrkmLdi62',
    defaultMessage: '{route}: arrival terminal changed from {previous} to {updated}.',
    description: 'Bullet describing a changed arrival terminal in the flight schedule comparison modal',
  },
  marketingAirline: {
    id: 'K9ctERGN_QGbnbMEh23C',
    defaultMessage: '{route}: marketing airline changed from {previous} to {updated}.',
    description: 'Bullet describing a changed marketing airline in the flight schedule comparison modal',
  },
  operatingAirline: {
    id: 'CVv0G9INSS-XxRst2_e3',
    defaultMessage: '{route}: operating airline changed from {previous} to {updated}.',
    description: 'Bullet describing a changed operating airline in the flight schedule comparison modal',
  },
  aircraftType: {
    id: 'LpWsoS4uxBKnJgWEkri5',
    defaultMessage: '{route}: aircraft changed from {previous} to {updated}.',
    description: 'Bullet describing a changed aircraft in the flight schedule comparison modal',
  },
  cabinClass: {
    id: 'Z40hwzhq5-1iuMUHiyCZ',
    defaultMessage: '{route}: cabin changed from {previous} to {updated}.',
    description: 'Bullet describing a changed cabin in the flight schedule comparison modal',
  },
  fareClass: {
    id: 'RO55nLQVC-QVMuHyPk28',
    defaultMessage: '{route}: fare changed from {previous} to {updated}.',
    description: 'Bullet describing a changed fare in the flight schedule comparison modal',
  },
  bookingClass: {
    id: 'BW94CXeuFQ128jsTTsFs',
    defaultMessage: '{route}: booking class changed from {previous} to {updated}.',
    description: 'Bullet describing a changed booking class in the flight schedule comparison modal',
  },
  fareFamilyName: {
    id: 'yCZesSssG1bu-eG-s54L',
    defaultMessage: '{route}: fare family changed from {previous} to {updated}.',
    description: 'Bullet describing a changed fare family in the flight schedule comparison modal',
  },
  duration: {
    id: 'fr8lNkc6gh3iotrl-1-m',
    defaultMessage: '{route}: travel duration changed from {previous} to {updated}.',
    description: 'Bullet describing a changed travel duration in the flight schedule comparison modal',
  },
  layover: {
    id: 'YwGWrY4A0evRYQIce9MT',
    defaultMessage: '{route}: layover duration changed from {previous} to {updated}.',
    description: 'Bullet describing a changed layover duration in the flight schedule comparison modal',
  },
  baggage: {
    id: 'XNznFnxgUJ3dNR86v7OX',
    defaultMessage: '{route}: baggage allowance changed. Review the updated and previous flight details.',
    description: 'Bullet identifying changed baggage allowance in the flight schedule comparison modal',
  },
  inclusions: {
    id: 'UeHlWUrjbXpBwe8m_-ah',
    defaultMessage: '{route}: inclusions changed. Review the updated and previous flight details.',
    description: 'Bullet identifying changed inclusions in the flight schedule comparison modal',
  },
  fareDetails: {
    id: 'a0eMqNT2V8EF0Ju2J4VP',
    defaultMessage: '{route}: fare details changed. Review the updated and previous flight details.',
    description: 'Bullet identifying changed fare details in the flight schedule comparison modal',
  },
  fareRules: {
    id: '5iamLh271SyHQmFolqu1',
    defaultMessage: '{route}: fare conditions changed. Review the updated and previous flight details.',
    description: 'Bullet identifying changed fare conditions in the flight schedule comparison modal',
  },
})

export const scheduleChangeComparisonMessages = defineMessages({
  updated: {
    id: 'BcVbnJkrRVDDJWSo3ZKD',
    defaultMessage: 'Updated flight details',
    description: 'Link and tab showing the updated itinerary in the schedule change comparison modal',
  },
  previous: {
    id: 'cXq8qPlHyWvisYYe0N47',
    defaultMessage: 'Previous flight details',
    description: 'Link and tab showing the previous itinerary in the schedule change comparison modal',
  },
})
